import React from 'react';
import { Send, CheckCircle2 } from 'lucide-react';
import { useContactForm } from '../../hooks/useContactForm';

export const ContactForm = () => {
  const { form, submitted, onChange, onSubmit } = useContactForm();

  return (
    <form className="contact-form" onSubmit={onSubmit} data-testid="contact-form">
      <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: 'var(--primary-navy)', marginBottom: '0.25rem' }}>
        Send a brief
      </h3>
      <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '0.5rem' }}>
        We'll respond on WhatsApp or email — typically within 2–4 working hours.
      </p>

      <div>
        <label htmlFor="cf-name">Full name</label>
        <input id="cf-name" name="name" type="text" required value={form.name} onChange={onChange} placeholder="e.g. Swarnava Sengupta" data-testid="contact-form-name" />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.85rem' }}>
        <div>
          <label htmlFor="cf-email">Email</label>
          <input id="cf-email" name="email" type="email" required value={form.email} onChange={onChange} placeholder="you@email.com" data-testid="contact-form-email" />
        </div>
        <div>
          <label htmlFor="cf-phone">Phone</label>
          <input id="cf-phone" name="phone" type="tel" value={form.phone} onChange={onChange} placeholder="+91-" data-testid="contact-form-phone" />
        </div>
      </div>

      <div>
        <label htmlFor="cf-message">How can we help?</label>
        <textarea
          id="cf-message"
          name="message"
          rows={5}
          required
          value={form.message}
          onChange={onChange}
          placeholder="Briefly describe your goal — wealth review, retirement planning, tax queries…"
          data-testid="contact-form-message"
        />
      </div>

      <button type="submit" className="btn-primary" style={{ alignSelf: 'flex-start', padding: '0.85rem 1.6rem' }} data-testid="contact-form-submit">
        {submitted ? (<><CheckCircle2 size={18} /> Opened in WhatsApp</>) : (<><Send size={16} /> Send via WhatsApp</>)}
      </button>

      <p style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '0.25rem' }}>
        By submitting, you agree to be contacted regarding your enquiry. No spam, ever.
      </p>
    </form>
  );
};
